import { Link } from "react-router-dom";
import type { MediaItem } from "@/types";
import { typeLabels } from "@/lib/labels";

interface MediaCardProps {
  item: MediaItem;
  showType?: boolean;
}

export default function MediaCard({ item, showType = false }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer"
      title={`${item.title}-${item.genres.join("、")}-榴莲视频`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title} 海报`}
          title={`${item.title} - ${typeLabels[item.type]} - 榴莲视频`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent opacity-80"></div>
        <span className="absolute left-2 top-2 rounded-md bg-background-50/80 px-2 py-0.5 text-xs font-medium text-accent-500 backdrop-blur-sm">
          {item.rating.toFixed(1)}
        </span>
        {showType && (
          <span className="absolute right-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs text-background-50">
            {typeLabels[item.type]}
          </span>
        )}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-500/90 text-background-50">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <p className="dv-clamp-1 text-sm font-medium text-foreground-950">{item.title}</p>
          <p className="mt-1 dv-clamp-1 text-xs text-foreground-300">
            {item.genres.slice(0, 2).join(" · ")}
          </p>
        </div>
      </div>
      <div className="mt-2 flex items-center gap-2 text-xs text-foreground-300">
        <span>{item.year}</span>
        <span className="h-3 w-px bg-background-300"></span>
        <span className="dv-clamp-1">{item.region}</span>
      </div>
    </Link>
  );
}